import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "trigger",
  "use": "trigger-usage",
  "viewBox": "0 0 32 49",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 49\" id=\"trigger\"><path d=\"M13.954 6.994v-4.5m6 6l3-3m-15 3l-3-3m16.5 7.5h4.5m-19.5 0h-4.5m9 34.5l-7.7-10.264a3.068 3.068 0 01-.098-3.54 3.068 3.068 0 014.39-.752l3.4 2.556V16a3 3 0 116 0v12l8.348 1.856a6 6 0 014.674 6.4L28.946 47.5l-17.992-.006z\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/trigger.svg
// module id = cOeF
// module chunks = 39 44